<div class="news-chartmap" [class.mobile]="(screenSize$ | async)?.isMobile">
  <div
    class="chart-main"
    id="chartcanvas"
    [class.mobile]="(screenSize$ | async)?.isMobile"
    [class.portfolio]="routing.isFolio()"
    [class.query]="routing.isQuery() || routing.isSearch()"
    [class.fulview]="params.folio || params.query"
    [class.score-focus]="
      routing.isChart() && (routing.isFolio() || routing.isMarket())
    "
    [class.score-focused]="params?.score"
  >
    <app-news-chart></app-news-chart>
  </div>

  <div
    class="chart-treemap"
    [class.hide]="params.type === 'hierarchy' || params.folio || params.query"
    *ngIf="
      params.type !== 'pne' &&
      params.type !== 'company' &&
      params.type !== 'hierarchy' &&
      !['industry', 'supersector', 'sector', 'subsector'].includes(
        params.type
      ) &&
      !(routing.isFolio() && routing.isChart()) &&
      !(routing.isQuery() && routing.isChart()) &&
      !(routing.isSearch() && routing.isChart())
    "
  >
    <app-news-treemap *ngIf="!routing.isNewsaudit()"></app-news-treemap>
  </div>
  <div
    *ngIf="
      routing.isChart() &&
      (routing.isFolio() || routing.isMarket()) &&
      params?.score
    "
    class="news-chartmap-divider"
    [style.border-color]="userState.scoreFocusedColor"
  ></div>
  <div
    class="chart-company"
    *ngIf="
      params.type === 'pne' ||
      params.type === 'company' ||
      params.type === 'hierarchy' ||
      ['industry', 'supersector', 'sector', 'subsector'].includes(
        params.type
      ) ||
      (routing.isFolio() && routing.isChart()) ||
      (routing.isQuery() && routing.isChart()) ||
      (routing.isSearch() && routing.isChart())
    "
    [class.score-focus]="
      routing.isChart() && (routing.isFolio() || routing.isMarket())
    "
    [class.score-focused]="params?.score"
    [style.border-color]="userState.scoreFocusedColor"
  >
    <app-chartmap-company></app-chartmap-company>
  </div>
</div>
